import React from 'react';
import { Component, ErrorInfo, ReactNode } from 'react';
import { withTranslation } from 'react-i18next';
import ReactPortal from '../portals/portals';
import ModalComponent from '../nds/modal/modal';
import './errorBoundary.scss';

interface Props {
    children?: ReactNode;
    t: any;
}

interface errorState {
    hasError?: boolean;
    isActive?: boolean;
}

class ErrorBoundary extends Component<Props, errorState> {
    constructor(props: Props | Readonly<Props>) {
        super(props);
        this.state = {
            isActive: true,
        };
        this.hideModal = this.hideModal.bind(this);
    }

    hideModal = () => {
        this.setState({ isActive: false });
    };

    public state: errorState = {
        hasError: false,
    };

    public static getDerivedStateFromError(): errorState {
        return { hasError: true };
    }

    /* eslint-disable no-console */
    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }

    portal = document.getElementById('portal-root') as HTMLElement;

    closeModal = () => {
        this.setState({
            isActive: false,
        });
    };

    translationErrorMessage = 'errorMessage';

    render() {
        const { t } = this.props;
        // console.log(t);
        if (this.state.hasError && false) {
            // disabled modal for now because of the lock issue(1143604) fix
            return (
                <ReactPortal wrapperId='portal-root'>
                    <ModalComponent show={this.state.isActive!} size={'lg'} header='' closeModal={this.closeModal}>
                        <h3 className='error-boundary-text'>{t('errorMessage.main')}</h3>
                        <p>{t('errorMessage.body')}</p>
                    </ModalComponent>
                    ,
                </ReactPortal>
            );
        }

        return this.props.children;
    }
}

export default withTranslation('lang')(ErrorBoundary);
